import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';



export default class Countdown extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            time_left: 99999999,         
        };
      }


    componentDidMount() {

        this.setState({time_left: this.props.time_allowed})

        this.interval = setInterval(() => {

            if(this.props.getPos(this.props.question) == 0)
            {
                this.setState({ time_left: this.state.time_left - 0.05})
                //console.log("time_left:", this.state.time_left)

                if(this.state.time_left <= 0)
                {
                  this.props.setResult(false, this.props.question)
                }
            }

            else
            {
              this.setState({time_left: this.props.time_allowed})
            }

            


        }, 50);
      }
    componentWillUnmount() {
        clearInterval(this.interval);
      }

  render() {


    var percent = Math.floor(this.state.time_left / this.props.time_allowed * 102)

    if(percent > 100) { percent = 100 }

    percent += "%"

    return (

      <div>

          <div class="count_down"></div>

          <div class="count_down_bar" style={{width: percent}}></div>

      </div>

    );
  }
}
